export default __webpack_public_path__ + "static/media/1.72146635.jpg";